import { customStyles } from '../../styles/customStyles';

const WatermarkSection = () => {
  return (
    <section id="watermark" className="py-24 relative">
      <div className="max-w-4xl mx-auto px-6 relative">
        <div className="absolute top-0 right-0 opacity-10 rotate-12 pointer-events-none">
          <div className="w-64 h-64 border-4 border-[#b7eb6f] rounded-full flex items-center justify-center">
            <div className="w-56 h-56 border border-dashed border-[#b7eb6f] rounded-full"></div>
          </div>
        </div>

        <div className="bg-[#FBF9F5] border border-[#D1D1C9] p-12 rounded-lg shadow-xl relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-2" style={customStyles.stripedTop}></div>

          <div className="flex flex-col md:flex-row gap-12 items-center">
            <div className="flex-1">
              <h2 className="font-serif-display text-4xl mb-4">Защищайте свою <br /><span className="italic text-[#b7eb6f]">интеллектуальную</span> собственность</h2>
              <p className="font-sans opacity-70 mb-6 text-sm leading-relaxed">
                Добавьте на каждую карточку настраиваемый водяной знак. Больше не нужно переживать о копировании. Trippy бережно сохраняет авторство.
              </p>
              <ul className="grid grid-cols-2 gap-y-2 font-typewriter text-xs text-[#1F1F1F]/60">
                <li>• Прозрачность</li>
                <li>• Позиция</li>
                <li>• Цвет</li>
                <li>• Динамическая подпись</li>
              </ul>
            </div>
            <div className="w-48 h-48 relative flex-shrink-0">
              <div className="w-full h-full bg-[#1F1F1F] rounded-lg flex items-center justify-center relative group overflow-hidden">
                <i className="ph-fill ph-image text-6xl text-white/20"></i>
                <div className="absolute inset-0 flex items-center justify-center opacity-50">
                  <span className="font-serif-display text-white text-2xl border-2 border-white px-4 py-1" style={{ transform: 'rotate(-45deg)' }}>PROTECTED</span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <i className="ph-fill ph-lock-key text-[#b7eb6f] text-2xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WatermarkSection;
